// Module
var code = "<ui-view> <record-grid-view grid-data-source=\"stateController.gridDataSource\" grid-settings=\"stateController.gridSettings\" columns=\"stateController.columns\" default-sort=\"'Name'\" default-query=\"stateController.defaultQuery\" name-singular=\"'project'\"> </record-grid-view> </ui-view> ";
// Exports
export default code;